import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function FinalCTA() {
  const { finalCTA } = useGiftData();
  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-airdoa-navy">
      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
              SPECIAL GIFT
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-white leading-tight whitespace-pre-line">
              {finalCTA.title}
            </h2>
            <p className="mt-5 text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
              {finalCTA.subtitle}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              {finalCTA.ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link
                      key={cta.href}
                      to={cta.href}
                      className="btn-primary w-full sm:w-auto justify-center"
                    >
                      {cta.label}
                      <span className="w-4 h-4 flex items-center justify-center ml-1.5">
                        <i className="ri-arrow-right-line" />
                      </span>
                    </Link>
                  );
                }
                return (
                  <Link
                    key={cta.href}
                    to={cta.href}
                    className="btn-ghost w-full sm:w-auto justify-center"
                  >
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={300}>
            <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-4 text-white/50 text-sm">
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </span>
                {finalCTA.contact.tel}
              </span>
              <span className="hidden sm:inline w-px h-3 bg-white/20" />
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line" />
                </span>
                {finalCTA.contact.hours}
              </span>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
